import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useExam } from "../context/ExamContext";

export default function ProtectedRoute({ children }) {
  const { currentUser } = useExam();
  const location = useLocation();

  const accessToken = localStorage.getItem("access_token");

  /*
   * The user is considered authenticated only when
   * both the React session and JWT access token exist.
   */

  if (!currentUser || !accessToken) {
    return (
      <Navigate
        to="/login"
        replace
        state={{
          from: location.pathname,
        }}
      />
    );
  }

  return children;
}